/**
 * If these parameters change we will need to also support the previous values as well.
 * There are Premiere UXP plugins bundled with Premiere which rely on these search
 * parameter keys working with auth.handleAuthCallback.
 */
export enum CREDENTIAL_KEYS {
  // Query parameters in the auth callback url
  CALLBACK_REFRESH_TOKEN = 'refreshToken',
  CALLBACK_SESSION_TOKEN = 'sessionToken',
  CALLBACK_ACCESS_TOKEN = 'token',
  CALLBACK_USER_ID = 'userId',

  // localStorage key
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  USER_ID = 'userId',
}

export const X_SHARE_ID_HEADER = 'x-frameio-share-id' as const;
export const X_UPLOAD_LINK_ID_HEADER = 'x-frameio-upload-link-id' as const;

// Legacy review-link / presentation routes (V3FRAME-2864): the middleware sets
// this to the legacy slug (a UUID), which the server puts in the standard
// share-auth header. The backend tells legacy from canonical via the GraphQL
// args (share(by: { reviewSlug | presentationSlug })), not this value.
export const X_LEGACY_SLUG_HEADER = 'x-frameio-legacy-slug' as const;

export const X_SHARE_AUTHORIZATION_HEADER =
  'x-frameio-share-authentication' as const;

export const X_UPLOAD_AUTHORIZATION_HEADER =
  'x-frameio-upload-link-authentication' as const;

export const X_UPLOAD_ACCESS_TOKEN_HEADER = 'x-upload-access-token' as const;

export const X_REQUEST_PATH_HEADER = 'x-frameio-request-path';

export const X_IDENTIFIED_USER_HEADER = 'x-frameio-identified-user-id' as const;

export const X_IDENTIFIED_USER_SESSION_ID_HEADER =
  'x-frameio-identified-user-session-id' as const;

export const IDENTIFIED_USER_COOKIE = 'identified_user_cookie' as const;

export const IDENTIFIED_USER_SESSION_ID_COOKIE =
  'identified_user_session_id_cookie' as const;

export const ANONYMOUS_USER = 'anonymous user' as const;

/**
 * Least aggressive buffer for use in middleware. This buffer is to account for
 * clock skew and the possibility of the token expiring between the server
 * response and the client hydration.
 **/
export const SERVER_SIDE_ACCESS_TOKEN_EXPIRATION_BUFFER_SECONDS = 30;

/**
 * More aggressive buffer for use in AuthRefreshLink. This buffer is to allow
 * the client to refresh the access tokens as client-side API requests are made.
 * The buffer is 6 minutes so that any prefetch requests—which are cached for 5
 * minutes—will expire and be re-prefetched before the access token that was used
 * to make that request expires.
 **/
export const CLIENT_SIDE_ACCESS_TOKEN_EXPIRATION_BUFFER_SECONDS = 360;

export const TEST_INVALID_ACCESS_TOKEN = 'invalid-access-token';
// Expires 2014-01-01
export const TEST_EXPIRED_ACCESS_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjEzODg3NTA0MDB9.test-signature';
export const TEST_EXPIRED_REFRESH_TOKEN =
  '00000000-0000-0000-0000-000000000000';

export const TEST_EXPIRED_SESSION_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjEzODg3NTA0MDB9.test-signature';
